export const AdapterType = {
    SP: "SP",
    API:"API"
  }